import { render, staticRenderFns } from "./DoneTaskSettings.vue?vue&type=template&id=45c6268f&scoped=true"
import script from "./DoneTaskSettings.vue?vue&type=script&lang=js"
export * from "./DoneTaskSettings.vue?vue&type=script&lang=js"
import style0 from "./DoneTaskSettings.vue?vue&type=style&index=0&id=45c6268f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c6268f",
  null
  
)

export default component.exports